export default {
  message: {
    Tour: {
      continue: "Kontinye",
      back: "Retounen",
      finish: "Fini"
    },
    Login: {
      title: "Koneksyon paran",
      sign_in: "Konekte",
      login_fail:
        "Otantifikasyon echwe. Tanpri eseye ankò oswa kontakte lekòl la pou asistans.",
      forgot_password: "Bliye modpas",
      create_account: "Kreye kont",
      password: "Modpas",
      confirm_password: "Konfime modpas",
      password_reminder: "Rapèl modpas",
      enter_email: "Antre adrès imèl ou",
      validation_error: "Mesaj erè validasyon",
      password_reminder_error_no_user_register:
        "Non itilizatè ou antre pa te jwenn. Tanpri eseye ankò oswa kreye nouvo kont.",
      password_reminder_error_no_user: "Non itilizatè ou antre pa te jwenn.",
      password_reminder_sent: "Yo voye yon imèl ak enstriksyon adisyonèl bay {email}.",
      password_reminder_sent_message:
        "Imèl la ka pran kèk minit pou rive. Si w pa wè l nan bwat lèt ou, tcheke katouch span.",
      password_trouble_email: "Si w toujou gen pwoblèm, kontakte {email}.",
      password_trouble_school:
        "Si w toujou gen pwoblèm, kontakte lekòl ou pou asistans.",
      return_to_sign_in: "Retounen nan koneksyon",
      create_my_account: "Kreye kont mwen",
      or_sign_in_with: "OSWA KONEKTE AK",
      password_reset: "Tanpri chwazi nouvo modpas pou kont ou.",
      password_reset_warning:
        "Si w pa t mande chanje modpas, tanpri kontakte administratè lekòl la imedyatman.",
      password_update: "Chwazi nouvo modpas",
      password_update_confirm: "Konfime nouvo modpas",
      password_update_success: "Nouvo modpas ou an te anrejistre."
    },
    AccountSettings: {
      title: "Paramèt kont",
      first_name: "Non",
      last_name: "Siyati",
      email: "Imèl",
      username: "Non itilizatè",
      password: "Modpas",
      students: "Elèv",
      teachers: "Pwofesè",
      external_id: "ID ekstèn",
      phone: "Nimewo telefòn",
      phone_required: "Nimewo telefòn obligatwa",
      edit: "Modifye",
      remove: "Efase",
      add: "Ajoute",
      remove_message: "Ou sèten ou vle efase non elèv sa a?",
      yes: "Wi",
      no: "Non",
      add_student: "Ajoute elèv",
      close: "Fèmen",
      save: "Anrejistre chanjman",
      cancel: "Anile",
      student_alert_message: "Ou dwe antre omwen yon elèv.",
      logout: "Dekonekte"
    },
    Navbar: {
      my_meetings: "Reinyon mwen yo",
      language: "Kreyòl ayisyen",
      help: "Èd",
      account_settings: "Paramèt kont",
      logout: "Dekonekte"
    },
    SubNavbar: {
      meeting: "Reinyon",
      event: "Evènman",
      print: "Enprime",
      email: "Imèl",
      export: "Ekspòte"
    },
    ConferenceCard: {
      add_edit_meetings: "Ajoute/Modifye reinyon",
      opening: "Ouvert",
      closed: "Fèmen"
    },
    Agenda: {
      full_agenda: "Aganda konplè",
      empty_state_title: "Nou pa jwenn okenn konferans pou ou.",
      empty_state_message: "Si w gen kesyon, tanpri kontakte reprezantan lekòl la.",
      confirmation_modal_title: "Aganda konfime",
      confirmation_modal_message:
        "Aganda ou a te konfime avèk siksè epi yo voye yon imèl pou ou.",
      complete_button: "Fini!"
    },
    AgendaCard: {
      room: "Chanm pa disponib",
      room_with_value: "Chanm: {room}",
      virtual_meeting: "Reinyon vityèl",
      all_conferences: "Tout konferans",
      conference: "Konferans",
      student: "Elèv",
      meeting_with: "Reinyon avèk",
      date_time: "Dat/Lè",
      meeting_type: "Kalite reinyon",
      location: "Kote",
      comment: "Kòmantè",
      action: "Aksyon",
      delete: "Efase",
      add_comment: "Ajoute kòmantè",
      join: "Antre nan reinyon an",
      choose_meeting_type: "Chwazi kalite reinyon",
      in_person: "An pèsonn",
      phone: "Telefòn",
      callback: "Rapèl",
      virtual: "Vityèl",
      unavailable: "Pa disponib",
      tooltip_translator:
        "Sèvis tradiktè pa garanti, men lekòl la ap fè tout efò pou asire li disponib.",
      translator_requested: "Tradiktè mande",
      clear_translator: "Efase demann tradiktè",
      need_translator: "Bezwen tradiktè?",
      choose_language: "Chwazi lang"
    },
    ScheduleMatrix: {
      no_teachers_title: "Okenn pwofesè oswa ekip pa chwazi.",
      no_teachers_message: "Tanpri chwazi yon pwofesè pou wè lè reinyon yo.",
      choose_teachers_button: "Gade pwofesè oswa ekip ki disponib",
      choose_student: "Pou ki elèv?",
      cancel: "Anile"
    },
    Matrix: {
      teachers: "Pwofesè",
      agenda: "Revize epi kontinye"
    },
    DrawerTeachers: {
      teachers: "Pwofesè",
      name: "Non",
      description: "Deskripsyon",
      student: "Elèv",
      teacher_team: "Pwofesè/Ekip",
      show_more: "Montre plis pwofesè",
      show_all: "Montre tout pwofesè lekòl la",
      selected: "({count}) chwazi",
      closeDrawer: "Kontinye planifye",
      search: "Chache pwofesè oswa ekip",
      not_available: "Pwofesè sa a pa gen okenn lè disponib sou {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "Ou pa gen okenn reinyon pwograme.",
      no_meetings_message: "Lè w chwazi yon pwofesè ak yon kren lè, reinyon an ap parèt isit la.",
      new_meeting_label: "Nouvo",
      cancel_button: "Anile",
      student_label: "Elèv",
      meeting_type_location: "Kalite reinyon/Kote",
      comment_label: "Kòmantè",
      save_comment_button: "Anrejistre kòmantè",
      confirm_label: "Tanpri konfime:",
      confirm_cancel_button: "Wi, anile reinyon mwen ak ",
      do_not_cancel_button: "Pa anile",
      confirm_agenda_button: "Konfime aganda sa a",
      confirm_agenda_message_line1: "Ou ka toujou retounen epi fè chanjman.",
      confirm_agenda_message_line2: "Yo ap voye aganda ou aktyèl la pou ou pa imèl."
    },
    EmailConsent: {
      message:
        "Nan efò pou pwoteje vi prive ou ak sekirite, nou bezwen konsantman ou pou resevwa kominikasyon soti nan sistèm nou an nan adrès imèl ou.",
      consent: "Mwen aksepte"
    }
  }
};
